import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModulesActions from "@/modules/entity/actions";

import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import getMenu from "./getMenu";
import get from "lodash/get";
import "./style.scss";
import Actions from "@/store/actions";

const Layout = (props) => {
  const dispatch = useDispatch();
  const [langTypes, setLangTypes] = useState([]);

  const { children } = props;
  const profile = useSelector((state) => state.auth.user);
  const loadClientLanguages = () => {
    dispatch(
      ModulesActions.LoadDefault.request({
        url: "/languages/client/get",
        cb: {
          success: (data) => {
            setLangTypes(data.data);
          },
          error: (data) => {},
        },
      }),
    );
  };

  const langCodes = langTypes.flatMap((item) =>
    Array.isArray(item.code) ? item.code : [item.code],
  );
  dispatch(Actions.system.SetLangCodes.trigger(langCodes));

  useEffect(() => {
    loadClientLanguages();
  }, []);
  return (
    <div className="devent-layout">
      <Sidebar menu={getMenu(get(profile, "role.role"))} />
      <div className="devent-body">
        <Header />
        <div className="devent-content">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
